module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    class: _vm.isMobile() ? 'modal--small' : 'modal--medium',
    style: (_vm.modalStyle()),
    attrs: {
      "show": _vm.show,
      "data-backdrop": "static",
      "clickToClose": "false",
      "data-keyboard": "false"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    style: (_vm.mainDivStyle())
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "20px",
      "cursor": "pointer"
    }
  }, [_c('img', {
    staticClass: "modal-back-arrow",
    attrs: {
      "src": require("../assets/img/icons/arrow_left.svg")
    },
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "foo",
    staticStyle: {
      "margin-bottom": "10px",
      "cursor": "pointer"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.downloadQrCode
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_download_qr_code')))])]), _vm._v(" "), _c('div', {
    staticClass: "profile-barcode-div"
  }, [_c('div', {
    staticClass: "profile-barcode-div outer-div"
  }, [_c('div', {
    staticClass: "profile-barcode-div inner-div",
    staticStyle: {
      "width": "80%",
      "padding-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "blue"
    }
  }, [_c('vue-qrcode', {
    ref: "qrcodeRef",
    attrs: {
      "value": _vm.qrData,
      "text": _vm.qrData,
      "size": _vm.isMobile() ? 256 : 512
    }
  })], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d3569804!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/ShowQrCodeDialog.vue
// module id = 828
// module chunks = 0